import { render, staticRenderFns } from "./FormFieldParent.vue?vue&type=template&id=4480dde2&scoped=true&"
import script from "./FormFieldParent.vue?vue&type=script&lang=js&"
export * from "./FormFieldParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4480dde2",
  null
  
)

export default component.exports